import { listingQuery } from "@/api/listings";
import { queryClient } from "@/api/utils";
import { ListingPage } from "@/components/listing-page";
import { ButtonLink } from "@/components/ui/Link";
import { checkIdPrefix } from "@/utils/id";
import { captureCustomEvent } from "@/utils/posthog";
import { seo } from "@/utils/seo";
import { Flex, Text } from "@givenwell/components";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app/marketplace/listings/$listingId")({
  loader: async ({ params: { listingId } }) => {
    checkIdPrefix(listingId, "LISTING");
    const data = await queryClient.ensureQueryData(listingQuery(listingId));
    captureCustomEvent("member_viewed_listing", {
      listing_id: listingId,
      listing_name: data.title,
      supplier_id: data.supplier.id,
      supplier_name: data.supplier.name,
    });
  },
  component: Component,
  notFoundComponent: NotFound,
  head: async ({ params }) => {
    const listing = await queryClient.ensureQueryData(listingQuery(params.listingId));
    return {
      meta: seo({
        title: listing.title,
      }),
    };
  },
});

function Component() {
  const { listingId } = Route.useParams();

  return <ListingPage listingId={listingId} />;
}

function NotFound() {
  return (
    <Flex css={{ flex: "1 0 0px", items: "center", justify: "center", flexDirection: "column", gap: 16 }}>
      <Text css={{ fontScale: "lg" }}>Listing not found</Text>
      <ButtonLink variant="filled" color="primary" to="/marketplace">
        Go back home
      </ButtonLink>
    </Flex>
  );
}
